import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/styles.css';
import '../styles/formularios.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png';

const ConsultarHorariosDocente = () => {
  const [docenteSeleccionado, setDocenteSeleccionado] = useState('');
  const [mostrarResultado, setMostrarResultado] = useState(false);
  const [nombreDocente, setNombreDocente] = useState('');
  const [horarios, setHorarios] = useState([]);

  const consultarHorario = () => {
    if (docenteSeleccionado !== '') {
      const docenteTexto = document.querySelector('#docente option:checked').text;
      setNombreDocente(docenteTexto);

      const datos = [
        { dia: "Lunes", horaInicio: "08:00", horaFin: "10:00", aula: "101" },
        { dia: "Miércoles", horaInicio: "10:00", horaFin: "12:00", aula: "102" },
        { dia: "Viernes", horaInicio: "08:00", horaFin: "10:00", aula: "101" }
      ];

      setHorarios(datos);
      setMostrarResultado(true);
    } else {
      alert("Por favor, selecciona un docente.");
    }
  };

  const exportarExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(document.getElementById('tablaHorarios'));
    XLSX.utils.book_append_sheet(wb, ws, "Horarios");
    XLSX.writeFile(wb, "horarios.xlsx");
  };

  const exportarPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({ html: '#tablaHorarios' });
    doc.save('horarios.pdf');
  };

  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Consulta de Horarios por Docentes</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Formulario */}
      <div className="p-4 bg-light rounded shadow-sm">
        <form className="row g-3">
          <div className="col-md-12">
            <label htmlFor="docente" className="form-label">Selecciona tu nombre</label>
            <select
              className="form-select"
              id="docente"
              value={docenteSeleccionado}
              onChange={(e) => setDocenteSeleccionado(e.target.value)}
            >
              <option value="">Selecciona un docente...</option>
              <option value="1">Juan Pérez</option>
              <option value="2">Ana García</option>
              <option value="3">Carlos Martínez</option>
            </select>
          </div>

          <div className="col-md-12">
            <button type="button" className="btn btn-primary w-100" onClick={consultarHorario}>
              Consultar Horario
            </button>
          </div>
        </form>
      </div>

      {/* Resultados */}
      {mostrarResultado && (
        <div id="resultadoConsulta" className="mt-4">
          <h5 className="text-center">
            Horario de clases de <span>{nombreDocente}</span>
          </h5>
          <table id="tablaHorarios" className="table table-bordered">
            <thead>
              <tr>
                <th>Día</th>
                <th>Hora de Inicio</th>
                <th>Hora de Finalización</th>
                <th>Aula</th>
              </tr>
            </thead>
            <tbody>
              {horarios.map((h, index) => (
                <tr key={index}>
                  <td>{h.dia}</td>
                  <td>{h.horaInicio}</td>
                  <td>{h.horaFin}</td>
                  <td>{h.aula}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Botones de exportación */}
          <div className="mt-3 d-flex justify-content-end gap-2">
            <button className="btn btn-outline-success" onClick={exportarExcel}>Exportar a Excel</button>
            <button className="btn btn-outline-danger" onClick={exportarPDF}>Exportar a PDF</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsultarHorariosDocente;

